// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { JobProcessRead } from "./JobProcessRead";
import {
  JobProcessReadFromJSON,
  JobProcessReadFromJSONTyped,
  JobProcessReadToJSON,
  JobProcessReadToJSONTyped,
} from "./JobProcessRead";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { JobState } from "./JobState";
import {
  JobStateFromJSON,
  JobStateFromJSONTyped,
  JobStateToJSON,
  JobStateToJSONTyped,
} from "./JobState";

/**
 *
 * @export
 * @interface JobRead
 */
export interface JobRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  projectId: string;
  /**
   * Workflow ID
   */
  workflowId?: string | null;
  /**
   *
   */
  name: string;
  /**
   *
   */
  startedAt?: Date | null;
  /**
   *
   */
  finishedAt?: Date | null;
  /**
   *
   */
  state: JobState;
  /**
   *
   */
  inputs: { [key: string]: any };
  /**
   *
   */
  process: JobProcessRead | null;
  /**
   *
   */
  creator: User;
}

/**
 * Check if a given object implements the JobRead interface.
 */
export function instanceOfJobRead(value: object): value is JobRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("process" in value) || value["process"] === undefined) return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  return true;
}

export function JobReadFromJSON(json: any): JobRead {
  return JobReadFromJSONTyped(json, false);
}

export function JobReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    projectId: json["project_id"],
    workflowId:
      json["workflow_id"] === undefined
        ? undefined
        : json["workflow_id"] === null
        ? null
        : json["workflow_id"],
    name: json["name"],
    startedAt:
      json["started_at"] === undefined
        ? undefined
        : json["started_at"] === null
        ? null
        : parseDateTime(json["started_at"]),
    finishedAt:
      json["finished_at"] === undefined
        ? undefined
        : json["finished_at"] === null
        ? null
        : parseDateTime(json["finished_at"]),
    state: JobStateFromJSON(json["state"]),
    inputs: json["inputs"],
    process: JobProcessReadFromJSON(json["process"]),
    creator: UserFromJSON(json["creator"]),
  };
}

export function JobReadToJSON(json: any): JobRead {
  return JobReadToJSONTyped(json, false);
}

export function JobReadToJSONTyped(
  value?: JobRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    project_id: value["projectId"],
    workflow_id: value["workflowId"],
    name: value["name"],
    started_at:
      value["startedAt"] == null ? value["startedAt"] : serializeDateTime(value["startedAt"]),
    finished_at:
      value["finishedAt"] == null ? value["finishedAt"] : serializeDateTime(value["finishedAt"]),
    state: JobStateToJSON(value["state"]),
    inputs: value["inputs"],
    process: JobProcessReadToJSON(value["process"]),
    creator: UserToJSON(value["creator"]),
  };
}
